import { Component } from "react";

import "./style.scss";

class ArrowsPaging extends Component {
    passPage(value){
        this.props.onPageChange(this.props.page+value);
    }

    render() {
        return (
            <>
                <div className="arrow-paging">
                    <div className={`arrow ${this.props.page<=0 ? "disable" : ""}`} onClick={()=>this.passPage(-1)}></div>
                    <div className="label"><span>{this.props.page+1}</span> of <span>{this.props.pages}</span></div>
                    <div className={`arrow ${this.props.page>=this.props.pages-1 ? "disable" : ""}`} onClick={()=>this.passPage(1)}></div>
                </div>
            </>
        )
    }
}

export default ArrowsPaging;